import { createReducer } from "@reduxjs/toolkit";

const initialState = {
  isLoading: true,
  product: null,
  products: [], 
  allProducts: [],
  success: false,
  error: null,
  message: null,
};

export const productReducer = createReducer(initialState, (builder) => {
  builder
    .addCase('productCreateRequest', (state) => {
      state.isLoading = true;
    })
    .addCase('productCreateSuccess', (state, action) => {
      state.isLoading = false;
      state.product = action.payload;
      state.success = true;
    })
    .addCase('productCreateFail', (state, action) => {
      state.isLoading = false;
      state.error = action.payload;
      state.success = false;
    })
    .addCase('getAllProductsShopRequest', (state) => {
      state.isLoading = true;
    })
    .addCase('getAllProductsShopSuccess', (state, action) => {
      state.isLoading = false;
      state.products = action.payload;
    })
    .addCase('getAllProductsShopFailed', (state, action) => {
      state.isLoading = false;
      state.error = action.payload;
    })
    .addCase('deleteProductRequest', (state) => {
      state.isLoading = true;
    })
    .addCase('deleteProductSuccess', (state, action) => {
      state.isLoading = false;
      // Remove the deleted product from the products array
      state.products = state.products.filter(product => product._id !== action.payload.id);
      state.message = action.payload.message;
    })
    
    .addCase('deleteProductFailed', (state, action) => {
      state.isLoading = false;
      state.error = action.payload;
    })
    .addCase('getAllProductsRequest', (state) => {
      state.isLoading = true;
    })
    .addCase('getAllProductsSuccess', (state, action) => {
      state.isLoading = false;
      state.allProducts = action.payload.products;
      state.page = action.payload.page;
      state.totalPages = action.payload.totalPages;
      state.totalProducts = action.payload.totalProducts;
    })
    
    .addCase('getAllProductsFailed', (state, action) => {
      state.isLoading = false;
      state.error = action.payload;
    })
    .addCase('getProductRequest', (state) => {
      state.isLoading = true;
    })
    .addCase('getProductSuccess', (state, action) => {
      state.isLoading = false;
      state.product = action.payload;
    })
    .addCase('getProductFail', (state, action) => {
      state.isLoading = false;
      state.error = action.payload;
    })
    .addCase('updateProductRequest', (state) => {
      state.isLoading = true;
    })
    .addCase('updateProductSuccess', (state, action) => {
      state.isLoading = false;
      state.product = action.payload;
      state.success = true;
      // Update the product in the products array
      state.products = state.products.map(product =>
        product._id === action.payload._id ? action.payload : product
      );
    })
    
    .addCase('updateProductFail', (state, action) => {
      state.isLoading = false;
      state.error = action.payload;
      state.success = false;
    })
    .addCase('clearErrors', (state) => {
      state.error = null;
      state.success = false;
    });
});

export default productReducer;
